<script setup>
// Wrapper léger sur HeadlessUI Dialog — modal centré avec overlay.
import { Dialog, DialogPanel, DialogTitle, TransitionRoot, TransitionChild } from '@headlessui/vue';

defineProps({
  open: { type: Boolean, required: true },
  title: { type: String, default: '' },
  size: { type: String, default: 'md' }, // sm, md, lg, xl, 2xl
});
defineEmits(['close']);
</script>

<template>
  <TransitionRoot
    appear
    :show="open"
    as="template"
  >
    <Dialog
      as="div"
      class="relative z-50"
      @close="$emit('close')"
    >
      <TransitionChild
        as="template"
        enter="duration-200 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-150 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/40" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4">
          <TransitionChild
            as="template"
            enter="duration-200 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-150 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              :class="[
                'w-full transform overflow-hidden rounded-xl bg-white shadow-xl transition-all',
                {
                  sm: 'max-w-sm',
                  md: 'max-w-md',
                  lg: 'max-w-2xl',
                  xl: 'max-w-4xl',
                  '2xl': 'max-w-6xl',
                  full: 'max-w-[95vw]',
                }[size],
              ]"
            >
              <div
                v-if="title"
                class="flex items-center justify-between border-b border-gray-100 px-5 py-3"
              >
                <DialogTitle class="text-base font-semibold text-gray-900">
                  {{ title }}
                </DialogTitle>
                <button
                  type="button"
                  class="text-gray-400 hover:text-gray-600 text-sm"
                  @click="$emit('close')"
                >
                  ✕
                </button>
              </div>
              <div class="px-5 py-4">
                <slot />
              </div>
              <div
                v-if="$slots.footer"
                class="border-t border-gray-100 px-5 py-3 bg-gray-50 flex items-center justify-end gap-2"
              >
                <slot name="footer" />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
